import React from 'react'
import CollegeFootball from 'src/components/page/college-football'
import { teamIds } from 'src/constants/personalizationIds'
export default (props) => (
  <CollegeFootball
    {...props}
    team="Michigan Wolverines"
    teamId={teamIds['Michigan Wolverines']}
    poster="https://assets-imgx.fubo.tv/marketing/lp/images/posters/CFB/Wolverines.png"
  />
)
